import styled from 'styled-components';
import {FlexColumn, FlexRow, mobileBreakPoint} from '../../StyledUtils';
import {FullStarsRow} from '../Popup/StyledPopup';

export const StyledSiteCard = styled(FlexColumn)`
  height: 252px;
  width: 252px;
  margin: 17px;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  @media (max-width: ${mobileBreakPoint}) {
    height: 352px;
    width: 352px;
  }
`;

export const StyledBgImage = styled.div`
  height: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 4px 4px 0px 0px;
  background-position: center center;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), 
    rgba(0, 0, 0, 0.3)), 
    url(${props => props.imgPath});
`;

export const ContentContainer = styled(FlexColumn)`
  height: 50%;
  justify-content: center;
  position: relative;
`;

export const Icon = styled.div`
  position: absolute;
  top: -16px;
  width: 32px;
  height: 32px;
  margin: 0px 16px;
  border-radius: 5px;
  background-size: cover;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url(${props => props.iconPath});
`;

export const Title = styled.a`
  font-size: 16px;
  margin: 0px 16px;
  font-weight: bold;
  line-height: 1.5;
  color: #252525;
  margin-top:7px;
  margin-bottom: 3px;
`;

export const Subtitle = styled.div`
  margin-left: 16px;
  color: #808080;
  font-size: 14px;
  line-height: 1.14;
`;

export const RatingsContainer = styled(FlexRow)`
  margin-top: 20px;
  align-items: center;
`;

export const Stars = styled.div`
  height: 24px;
  width: 120px;
  margin: 0px 4px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url(${props => props.starsPath});
`;
